import { Button, Divider, Drawer, Form } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppBar, CheckBoxSelector, Input } from "../index.js";
// import langDict from "./langDict.json";
import { envChangeType } from "../../plugins/utils.js";
import CloudflareAuth from "../CloudflareAuth/index.jsx";
import {
  useGetUserAreaCode,
  useGetUserForgetSendVerify,
  usePostMobileSend,
  usePostMobileVerify,
  usePutForgetPassword,
  useResolveDefaultAreaCode,
} from "./hooks/bind.hook.js";
import {
  buildAreaCodeOption,
  CountryFlag,
  getCountryCodeFromAreaCodeItem,
} from "./utils/countryFlag.jsx";

const COOLDOWN_SEC = 60;
let cooldownNumber;
let cooldownInterval;
const BindMobilePopup = ({
  visible,
  setVisible,
  onBeforeFinish,
  isForgetPassword = false,
  account,
  title = null,
}) => {
  const [cooldown, setCooldown] = useState();
  const [showSelectAreaCode, setShowAreaCode] = useState(false);
  const [sendCount, setSendCount] = useState(0);
  const { data: areaCode } = useGetUserAreaCode({
    enabled: visible === true,
  });
  const { areaCodeSelected, setAreaCodeSelected } = useResolveDefaultAreaCode(
    areaCode,
    visible === true,
  );
  const { mutate: mobileSend } = usePostMobileSend();
  const { mutate: forgetMobileSend } = useGetUserForgetSendVerify();
  const { mutate: mobileVerify } = usePostMobileVerify({
    onSuccess: onBeforeFinish,
  });

  const { mutate: forgetPassword } = usePutForgetPassword({
    onSuccess: onBeforeFinish,
  });
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const currentAreaCode = areaCode?.find((a) => a.area_code === areaCodeSelected);

  const [showIsNotPassCloudflare, setShowIsNotPassCloudflare] = useState(false);
  const [cloudflareToken, setCloudflareToken] = useState("");

  const initCoolDown = () => {
    setCooldown(COOLDOWN_SEC);
    cooldownNumber = COOLDOWN_SEC;
    cooldownInterval = setInterval(() => {
      setCooldown(cooldownNumber - 1);
      cooldownNumber = cooldownNumber - 1;
      if (cooldownNumber <= 0) {
        setCooldown(undefined);
        cooldownNumber = undefined;
        clearInterval(cooldownInterval);
      }
    }, 1000);
  };

  const onClose = () => {
    setVisible(false);
    form.resetFields();
    setCloudflareToken(false);
  };
  const getCode = async () => {
    try {
      const mobileProviderArr = currentAreaCode?.mobile_provider?.split(",");
      await form.validateFields(["mobile"]);
      const params = {
        mobile: form.getFieldValue("mobile"),
        area_code: areaCodeSelected,
        type:
          mobileProviderArr && mobileProviderArr.length > 0
            ? mobileProviderArr[sendCount % mobileProviderArr?.length || 0]
            : "",
      };
      if (!cloudflareToken && envChangeType("REACT_APP_LOGIN_CLOUDFLARE_KEY")) {
        setShowIsNotPassCloudflare(true);
        return;
      }
      initCoolDown();
      setSendCount(sendCount + 1);
      if (cooldown === undefined) {
        if (isForgetPassword) {
          forgetMobileSend({
            ...params,
            area_code: areaCodeSelected,
            type: "mobile",
            account,
          });
        } else {
          mobileSend(params);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  const onFinish = (form) => {
    if (!cloudflareToken && envChangeType("REACT_APP_LOGIN_CLOUDFLARE_KEY")) {
      setShowIsNotPassCloudflare(true);
      return;
    }
    if (isForgetPassword) {
      forgetPassword({ ...form, account: account, type: "mobile" });
    } else {
      mobileVerify({ ...form, area_code: areaCodeSelected });
    }
  };

  const renderTitle = () => {
    if (isForgetPassword === true) return null;
    return (
      <div
        style={{
          color: "var(--color-text-main)",
          fontSize: "var(--fontSetting-huge)",
        }}
      >
        {t("normal.bindMobile")}
      </div>
    );
  };

  const renderMobile = () => {
    if (isForgetPassword === true) return null;
    return (
      <Input
        name="mobile"
        label={t("normal.mobile")}
        addonBefore={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowAreaCode(true);
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <CountryFlag
                countryCode={getCountryCodeFromAreaCodeItem(currentAreaCode)}
                size="small"
              />
              <div>{currentAreaCode ? `+${currentAreaCode?.area_code}` : ""}</div>
            </div>
            <Divider type="vertical" />
          </div>
        }
        placeholder={t("form.holder.pleaseEnter")}
        rules={[
          {
            required: true,
            message: t("form.required", { name: t("normal.mobile") }),
          },
        ]}
      />
    );
  };

  const renderForgetPasswordForm = () => {
    if (isForgetPassword === false) return null;
    return (
      <>
        <Input
          name="new_password"
          label={t("signup.newPassword")}
          placeholder={t("form.holder.pleaseEnter")}
          password={true}
          rules={[
            {
              required: true,
              message: t("form.required", {
                name: t("signup.newPassword"),
              }),
            },
            {
              min: 6,
              max: 16,
              message: t("normal.validation.length.error", {
                name: t("signup.newPassword"),
                min: 6,
                max: 16,
              }),
            },
          ]}
        />
        <Input
          name="confirm_new_password"
          label={t("signup.confirmNewPassword")}
          dependencies={["password"]}
          placeholder={t("form.holder.pleaseEnter")}
          password={true}
          rules={[
            {
              required: true,
              message: t("form.required", {
                name: t("signup.confirmNewPassword"),
              }),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error(t("signup.confirmPasswordError")));
              },
            }),
          ]}
        />
      </>
    );
  };

  return (
    <>
      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        open={visible}
        destroyOnClose={true}
        bodyStyle={{ padding: "0" }}
        width={"100%"}
        style={{ maxWidth: "var(--maxWidth-in-pc)", margin: "0 auto" }}
      >
        <AppBar
          title={title ? title : t("normal.bindMobile")}
          onClickEvent={() => {
            onClose();
          }}
        />
        <div style={{ padding: 16 }}>
          {renderTitle()}
          <Form
            form={form}
            name="resetPassword"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            autoComplete="off"
            requiredMark={false}
            layout="vertical"
          >
            {renderMobile()}
            <Input
              name="code"
              label={t("forgot.verifyMobileCode")}
              placeholder={t("form.holder.pleaseEnter")}
              addonAfter={
                <div
                  style={{
                    color:
                      cooldown === undefined
                        ? "var(--color-login-button-text-active)"
                        : "var(--color-text-unstable)",
                    fontWeight: 500,
                  }}
                  onClick={() => {
                    getCode();
                  }}
                >
                  {cooldown === undefined
                    ? t("forgot.sendCode")
                    : t("forgotPassword.cooldown", { sec: cooldown })}
                </div>
              }
              rules={[
                {
                  required: true,
                  message: t("form.required", {
                    name: t("forgot.verifyMobileCode"),
                  }),
                },
              ]}
            />
            {renderForgetPasswordForm()}
            {envChangeType("REACT_APP_LOGIN_CLOUDFLARE_KEY") && (
              <CloudflareAuth
                theme={"light"}
                style={{ marginBottom: "16px" }}
                isModalVisible={showIsNotPassCloudflare}
                setIsModalVisible={setShowIsNotPassCloudflare}
                setCloudflareToken={setCloudflareToken}
              />
            )}

            <Button
              block
              size="large"
              style={{ width: "100%", borderRadius: "8px" }}
              type="primary"
              htmlType="submit"
            >
              {t("normal.confirm")}
            </Button>
          </Form>
        </div>
      </Drawer>
      <Drawer
        open={showSelectAreaCode}
        onClose={() => {
          setShowAreaCode(false);
        }}
        width={"100%"}
        destroyOnClose={true}
        closable={false}
        bodyStyle={{ padding: "0" }}
        style={{ maxWidth: "var(--maxWidth-in-pc)", margin: "0 auto" }}
      >
        <AppBar
          title={t("normal.areaCode")}
          onClickEvent={() => {
            setShowAreaCode(false);
          }}
        />
        <CheckBoxSelector
          options={areaCode?.map((item) => buildAreaCodeOption(item))}
          selectedOption={areaCodeSelected}
          onChange={(target) => setAreaCodeSelected(target.value)}
          setShowDrawer={setShowAreaCode}
        />
      </Drawer>
    </>
  );
};

export default BindMobilePopup;
